<!-- eslint-disable -->
<template lang="pug">
    .settings(v-if='settings')
        template(v-if="parametersFrom === 'homework'")
            | {{ $i18n.t('trainer.trainer_gameFormSetting_mode') }}: {{ $i18n.t('trainer.trainer_gameFormSetting_' + settings.firstMode) }}
            br
            | {{ $i18n.t('trainer.trainer_gameFormSetting_mode') }}: {{ $i18n.t('trainer.trainer_gameFormSetting_' + settings.secondMode) }}
            br
            | {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfPairs') }}: {{ settings.amountOfPairs }}
            br
            template(v-if='settings.amountOfExamples')
                | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}: {{ settings.amountOfExamples }}
                br
            | {{ $i18n.t('trainer.trainer_gamePlayBox_tip') }}: {{ $i18n.t(settings.isHintEnabled ? 'progress.progress_preview_statusOn' : 'progress.progress_preview_statusOf') }}
        slot

</template>

<script>
    /*eslint-disable*/
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            userId: Number,
            parametersFrom: {
                type: String,
                default: 'homework',
            },
        },
    };
</script>
